module.exports = "../dist/img/product-detail-2-17.62ec.jpg";